module.exports = __webpack_public_path__ + "static/0026-e63954807bb76a2e69634734c4c4f3f3.png";